module.exports = __webpack_public_path__ + "static/media/bg_rectangle-light-2.4af6807a.jpg";